import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Plus, Search, BedDouble } from "lucide-react";

const STATUS = {
  paid: "border-emerald-200 bg-emerald-50 text-emerald-700",
  partial: "border-amber-200 bg-amber-50 text-amber-700",
  due: "border-rose-200 bg-rose-50 text-rose-700",
  refunded: "border-purple-200 bg-purple-50 text-purple-700",
};

export default function Billing() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = async (s = "") => {
    const { data } = await api.get("/billing/invoices", { params: { q: s } });
    setItems(data.items);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="section-label">Cashier</div>
          <h1 className="font-heading text-3xl font-semibold">Billing & invoices</h1>
        </div>
        <div className="flex gap-2">
          <Link to="/app/ipd"><Button variant="outline" data-testid="billing-ipd-btn"><BedDouble size={14} className="mr-2" />IPD Billing</Button></Link>
          <Link to="/app/billing/new"><Button className="bg-brand hover:bg-brand-700" data-testid="billing-new-btn"><Plus size={14} className="mr-2" />New invoice</Button></Link>
        </div>
      </div>

      <Card className="p-4">
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-subtle" />
            <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search by invoice no, patient, UHID…" className="pl-9" onKeyDown={(e) => e.key === "Enter" && load(q)} />
          </div>
          <Button variant="outline" onClick={() => load(q)}>Search</Button>
        </div>
      </Card>

      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3 text-left">Invoice #</th>
                <th className="px-4 py-3 text-left">Patient</th>
                <th className="px-4 py-3 text-right">Total</th>
                <th className="px-4 py-3 text-right">Paid</th>
                <th className="px-4 py-3 text-right">Balance</th>
                <th className="px-4 py-3 text-left">Mode</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {items.length === 0 && <tr><td colSpan="9" className="px-4 py-10 text-center text-ink-muted">No invoices yet.</td></tr>}
              {items.map(i => (
                <tr key={i.id} className="row-enter hover:bg-secondary/40">
                  <td className="px-4 py-3 font-mono text-xs">{i.invoice_no}</td>
                  <td className="px-4 py-3"><div className="font-medium">{i.patient_name}</div><div className="text-[11px] text-ink-muted font-mono">{i.patient_uhid}</div></td>
                  <td className="px-4 py-3 text-right font-medium">₹ {Number(i.total).toLocaleString("en-IN")}</td>
                  <td className="px-4 py-3 text-right">₹ {Number(i.amount_paid).toLocaleString("en-IN")}</td>
                  <td className="px-4 py-3 text-right">₹ {Number(i.balance).toLocaleString("en-IN")}</td>
                  <td className="px-4 py-3 capitalize">{i.payment_mode}</td>
                  <td className="px-4 py-3"><Badge variant="outline" className={STATUS[i.status] || ""}>{i.status}</Badge></td>
                  <td className="px-4 py-3 text-xs text-ink-muted">{(i.created_at || "").slice(0,10)}</td>
                  <td className="px-4 py-3 text-right"><Link to={`/app/billing/${i.id}`}><Button size="sm" variant="outline">View</Button></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
